import React from 'react';

import './style.css';

const TimelineItem = ({ children, disabled = false }) => {
    return <div className={`timeline__item ${disabled && 'disabled'}`}>{children}</div>;
};

export default TimelineItem;
